import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faUserCircle,
    faCat,
    faCrow,
    faDog,
    faDolphin,
    faDove,
    faDuck,
    faElephant,
    faFishFins,
    faFrog,
    faHippo,
    faHorse,
    faKiwiBird,
    faMouseField,
    faOtter,
    faPig,
    faRabbit,
    faScreencast as fadScreencast,
    faShareFromSquare as fadShareFromSquare,
    faSheep,
    faSpinnerThird,
    faSquirrel,
    faTurtle,
    faWhale
} from "@fortawesome/pro-duotone-svg-icons";
import {
    faAddressCard as falAddressCard,
    faArrowLeft,
    faBooks as falBooks,
    faBuildings as falBuildings,
    faCalendarCheck as falCalendarCheck,
    faCalendarDays,
    faCalendars,
    faChevronDown as falChevronDown,
    faChevronRight as falChevronRight,
    faChevronUp as falChevronUp,
    faCircleInfo as falCircleInfo,
    faClipboardQuestion,
    faClockRotateLeft as falClockRotateLeft,
    faClockSeven,
    faEllipsis,
    faEnvelope as falEnvelope,
    faExclamationTriangle as falExclamationTriangle,
    faListOl,
    faTriangleExclamation as falTriangleExclamation,
    faMemoPad,
    faMessages as falMessages,
    faMicrophone,
    faMicrophoneSlash,
    faMoneyCheckDollarPen,
    faNewspaper as falNewspaper,
    faNote,
    faPalette,
    faPersonHarassing,
    faScreencast as falScreencast,
    faShareFromSquare as falShareFromSquare,
    faShieldKeyhole,
    faTags,
    faTicket,
    faTrashClock,
    faUser,
    faUsers as falUsers,
    faVideo,
    faVideoSlash,
    faWebhook,
    faWindowRestore,
} from "@fortawesome/pro-light-svg-icons";
import {
    faAddressCard,
    faAnglesUpDown,
    faArrowsUpDownLeftRight,
    faArrowTurnDownRight as fasArrowTurnDownRight,
    faArrowUpArrowDown as fasArrowUpArrowDown,
    faBars,
    faBooks as fasBooks,
    faBug,
    faBuildings as fasBuildings,
    faCheck as fasCheck,
    faCalendarCheck as fasCalendarCheck,
    faCalendarDays as fasCalendarDays,
    faCalendarDay,
    faCalendarWeek,
    faCalendarStar,
    faCirclePlus as fasCirclePlus,
    faCircleStar as fasCircleStar,
    faCircleXmark as fasCircleXmark,
    faClock,
    faClockRotateLeft,
    faChartSimple,
    faChevronDown as fasChevronDown,
    faAngleLeft,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleExclamation as fasCircleExclamation,
    faCircleUserCircleXmark,
    faDiamondHalfStroke,
    faEllipsis as fasEllipsis,
    faEllipsisVertical,
    faFile,
    faFileArrowDown,
    faFileArrowUp,
    faFileSlash,
    faFilter,
    faLink,
    faList,
    faListCheck,
    faMessages as fasMessages,
    faMicrophoneSlash as fasMicrophoneSlash,
    faNewspaper as fasNewspaper,
    faPersonChalkboard as fasPersonChalkboard,
    faPlus as fasPlus,
    faPlusLarge,
    faSquareCaretRight,
    faStar,
    faTimes,
    faTriangleExclamation as fasTriangleExclamation,
    faUserGroupSimple,
    faUser as fasUser,
    faUsers as fasUsers,
    faUsersGear,
    faUserPlus as fasUserPlus,
    faVideo as fasVideo,
    faVideoSlash as fasVideoSlash,
    faVolume as fasVolume,
    faXmarkCircle,
    faXmarkLarge,
} from '@fortawesome/pro-solid-svg-icons'
import {
    faAngleUp,
    faAngleDown,
    faArrowDown,
    faArrowPointer,
    faArrowRight,
    faArrowUp,
    faArrowUpArrowDown,
    faArrowTurnDownRight,
    faBadgeCheck,
    faBan,
    faBookmark,
    faBrowser,
    faCalendarCheck,
    faCalendarCirclePlus,
    faCalendarClock,
    faCalendarLinesPen,
    faCalendarPlus,
    faCheck as farCheck,
    faCheckCircle,
    faCheckDouble,
    faChevronLeft as farChevronLeft,
    faChevronRight as farChevronRight,
    faClock as farClock,
    faCommentSms,
    faCopy,
    faCircleChevronRight,
    faCircleChevronLeft,
    faCircleExclamation,
    faCircleInfo,
    faCircleXmark,
    faCirclePlus,
    faCircleStar,
    faClipboardCheck,
    faClipboardListCheck,
    faComputerClassic,
    faDoorClosed,
    faDoorOpen,
    faDownload,
    faEnvelope,
    faEnvelopeDot,
    faEnvelopeOpen,
    faExclamationCircle,
    faExclamationTriangle as farExclamationTriangle,
    faFaceSmile,
    faGlobePointer,
    faHandshake,
    faHandWave,
    faHourglass,
    faInfoCircle,
    faLanguage,
    faLaptopMobile,
    faMailboxFlagUp,
    faMessageExclamation,
    faMessagePlus,
    faMessageQuestion,
    faMessages as farMessages,
    faMessageSms,
    faMinus,
    faNoteSticky,
    faPenToSquare,
    faPersonBurst,
    faPersonChalkboard,
    faPersonCirclePlus,
    faPersonFromPortal,
    faPersonToDoor,
    faPersonWalkingDashedLineArrowRight,
    faPlus,
    faReply,
    faScreencast,
    faShareFromSquare,
    faSquare,
    faSquareCheck,
    faSquareXmark,
    faSubtitlesSlash,
    faTrash,
    faTrashCan,
    faUpRightFromSquare,
    faUserClock,
    faUserPlus,
    faUsers as farUsers,
    faVideo as farVideo,
    faVolume,
    faXmark,
} from "@fortawesome/pro-regular-svg-icons";

library.add(
    faAddressCard,
    faBadgeCheck,
    faTrash,
    faCircleXmark,
    faAngleDown,
    faAngleUp,
    faAnglesUpDown,
    faArrowDown,
    faArrowLeft,
    faArrowPointer,
    faArrowRight,
    faArrowTurnDownRight,
    faArrowUp,
    faArrowUpArrowDown,
    faArrowsUpDownLeftRight,
    faBan,
    faBars,
    faBookmark,
    faBrowser,
    faBug,
    faCalendarCheck,
    faCalendarCirclePlus,
    faCalendarClock,
    faCalendarDays,
    faCalendarLinesPen,
    faCalendarPlus,
    faCalendarDay,
    faCalendarWeek,
    faCalendars,
    faCalendarStar,
    faCat,
    faChartSimple,
    faCheckCircle,
    faCheckDouble,
    faCommentSms,
    faAngleLeft,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleChevronLeft,
    faCircleChevronRight,
    faCircleExclamation,
    fasCircleExclamation,
    faCircleInfo,
    faCircleUserCircleXmark,
    faClipboardQuestion,
    faClipboardCheck,
    faClipboardListCheck,
    faClock,
    faClockRotateLeft,
    faClockSeven,
    faCrow,
    faCirclePlus,
    faCircleStar,
    faComputerClassic,
    faCopy,
    faDiamondHalfStroke,
    faDog,
    faDolphin,
    faDoorClosed,
    faDoorOpen,
    faDove,
    faDownload,
    faDuck,
    faElephant,
    faEllipsis,
    faEllipsisVertical,
    faEnvelope,
    faEnvelopeDot,
    faEnvelopeOpen,
    faExclamationCircle,
    faFaceSmile,
    faFile,
    faFileArrowDown,
    faFileArrowUp,
    faFileSlash,
    faFilter,
    faFishFins,
    faFrog,
    faGlobePointer,
    faHandshake,
    faHandWave,
    faHippo,
    faHorse,
    faHourglass,
    faInfoCircle,
    faKiwiBird,
    falAddressCard,
    faLaptopMobile,
    falCircleInfo,
    falClockRotateLeft,
    faLanguage,
    faLink,
    faList,
    faListCheck,
    faListOl,
    faMailboxFlagUp,
    faMemoPad,
    faMessageExclamation,
    faMessagePlus,
    faMessageQuestion,
    faMessageSms,
    faMicrophone,
    faMicrophoneSlash,
    faMinus,
    faMoneyCheckDollarPen,
    faMouseField,
    faNote,
    faNoteSticky,
    faOtter,
    faPalette,
    faPenToSquare,
    faPersonBurst,
    faPersonChalkboard,
    faPersonCirclePlus,
    faPersonHarassing,
    faPersonFromPortal,
    faPersonToDoor,
    faPersonWalkingDashedLineArrowRight,
    faPig,
    faPlus,
    faPlusLarge,
    faRabbit,
    faReply,
    fasCirclePlus,
    fasCircleStar,
    fasCircleXmark,
    fasPersonChalkboard,
    faScreencast,
    faShareFromSquare,
    faSheep,
    faShieldKeyhole,
    faSpinnerThird,
    faSubtitlesSlash,
    faSquare,
    faSquareCaretRight,
    faSquareCheck,
    faSquareXmark,
    faSquirrel,
    faStar,
    faTags,
    faTicket,
    faTimes,
    faTrashCan,
    faTrashClock,
    faTurtle,
    faUpRightFromSquare,
    faUser,
    faUserCircle,
    faUserClock,
    faUserGroupSimple,
    faUserPlus,
    faUsersGear,
    faVideo,
    faVideoSlash,
    faWebhook,
    faWhale,
    faWindowRestore,
    faXmarkCircle,
    fadScreencast,
    fadShareFromSquare,
    falBooks,
    falBuildings,
    falCalendarCheck,
    falChevronDown,
    falChevronRight,
    falChevronUp,
    falEnvelope,
    falExclamationTriangle,
    falMessages,
    falNewspaper,
    falScreencast,
    falShareFromSquare,
    falTriangleExclamation,
    falUsers,
    farCheck,
    farChevronLeft,
    farChevronRight,
    farClock,
    farExclamationTriangle,
    farMessages,
    farUsers,
    farVideo,
    fasArrowUpArrowDown,
    fasBooks,
    fasBuildings,
    fasCalendarCheck,
    fasCalendarDays,
    fasCheck,
    fasChevronDown,
    fasEllipsis,
    fasMessages,
    fasNewspaper,
    fasPlus,
    fasTriangleExclamation,
    fasArrowTurnDownRight,
    fasUser,
    fasUserPlus,
    fasUsers,
    fasVideo,
    fasVideoSlash,
    fasMicrophoneSlash,
    fasVolume,
    faVolume,
    faXmark,
    faXmarkLarge,
)
